<template>
    <v-select label="name" :options="options" :clearable="false" @input="updateVal" :value="value" :disabled="disabled">
        <template #open-indicator>
            <feather type="chevron-down"></feather>
        </template>
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                No hay resultados para <em>{{ search }}</em>.
            </template>
        </template>
    </v-select>
</template>
<script>
export default {
  props: {
    options:
      {
        type: Array,
        default: () => []
      },
    value: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    updateVal (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
